import * as quota from '../../src/utils/quota'
import type { Cust_TServerPrefs } from '../Cust/Cust.serverPrefs'

export const Rpts_defaultMinSpaceForReport = 30 * 1000000 // 30mb, 30 x 1,000,000 bytes

/**
 * Returns boolean to signify if there is enough space
 * Uses the minSpaceForReport in the serverPrefs but falls back to the default (Rpts.defaultMinSpaceForReport)
 */
export async function Rpts_enoughSpaceToStartReport(
    serverPrefs: Cust_TServerPrefs,
    deps: { quota: typeof quota } = { quota }
): Promise<boolean> {
    let spaceRemaining: number

    try {
        const bytes = await deps.quota.queryUsageAndQuota()
        spaceRemaining = bytes.grantedBytes - bytes.usedBytes
    } catch (err) {
        // No quota info available, we shouldnt block report creation
        return true
    }

    const minSpaceForReport = serverPrefs.minSpaceForReport || Rpts_defaultMinSpaceForReport

    return spaceRemaining >= minSpaceForReport
}
